import stylesCss from "./image-with-preview.module.css";
import { useState } from "react";

import { Flex, Image, Space } from "antd";

import DownloadIcon from "@/icons/DownloadIcon";
import ZoomInIcon from "@/icons/ZoomInIcon";
import ZoomOutIcon from "@/icons/ZoomOutIcon";
import ImageIcon from "@/icons/ImageIcon";
import ArrowTopRightIcon from "@/icons/ArrowTopRightIocn";

const ImageWithPreview = ({
  children,
  uuid,
  original_name,
  name,
  extension,
  className = "",
  styles,
  is_shortcut = false,
  src,
  previewSrc,
  downloadHref,
}) => {
  const [showPreview, setShowPreview] = useState(false);

  const href = downloadHref || src || `/api/file/download?uuid=${uuid}`;
  const path = previewSrc || src || `/api/file/preview?uuid=${uuid}`;

  const onDownload = () => {
    const link = document.createElement("a");
    link.href = href;
    link.download = original_name;
    link.click();
  };

  return (
    <>
      <Flex
        gap={5}
        align="center"
        className={`${stylesCss.wrap} ${className}`.trim()}
        style={styles}
        onClick={() => setShowPreview(true)}
      >
        {children || (
          <>
            <div style={{ position: "relative", height: 22 }}>
              <ImageIcon
                style={{ color: "var(--color-secondary)", fontSize: "22px" }}
              />
              {is_shortcut && (
                <ArrowTopRightIcon
                  style={{
                    position: "absolute",
                    bottom: -1,
                    left: 0,
                    fontSize: "12px",
                    color: "var(--color-secondary)",
                    background: "#fff",
                    borderRadius: 4,
                  }}
                />
              )}
            </div>
            <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
              {name}.{extension}
            </div>
          </>
        )}
      </Flex>
      <div style={{ display: "none" }}>
        <Image
          src={path}
          style={{ display: "none" }}
          preview={{
            open: showPreview,
            src: path,
            onOpenChange: (value) => {
              setShowPreview(value);
            },
            actionsRender: (
              _,
              {
                transform: { scale },
                actions: { onRotateLeft, onRotateRight, onZoomOut, onZoomIn },
              },
            ) => (
              <Space size={12}>
                <DownloadIcon onClick={onDownload} style={{ fontSize: 24 }} />
                {/* <RotateLeftOutlined onClick={onRotateLeft} />
                <RotateRightOutlined onClick={onRotateRight} /> */}
                <ZoomOutIcon
                  disabled={scale === 1}
                  onClick={onZoomOut}
                  style={{ fontSize: 24 }}
                />
                <ZoomInIcon
                  disabled={scale === 50}
                  onClick={onZoomIn}
                  style={{ fontSize: 24 }}
                />
              </Space>
            ),
          }}
        />
      </div>
    </>
  );
};

export default ImageWithPreview;
